import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SsoResourcesNavigationType } from 'src/app/app-routing.module';
import { Global } from '../../global';
import { AuthenticationService } from '../../services/authentication.service';

@Component({
  selector: 'app-sso',
  templateUrl: './sso.component.html',
  styleUrls: ['./sso.component.scss'],
})
export class SsoComponent implements OnInit {
  loading = true;
  errorMessage: string;

  constructor(private router: Router, private route: ActivatedRoute, private authenticationService: AuthenticationService) {}

  ngOnInit() {
    this.route.data.subscribe((data) => {
      this.route.queryParamMap.subscribe((queryParams) => {
        const token = queryParams.get('token');

        this.authenticationService.ssoLogin(token, false).subscribe(
          (result) => {
            if (result) {
              if (data?.ssoResourceNavigationType) {
                this.route.params.subscribe((params) => {
                  this.authenticationService.currentUserSubject.subscribe((user) => {
                    switch (data?.ssoResourceNavigationType) {
                      case SsoResourcesNavigationType.OnlineCourse:
                        if (!params.onlineCourseId) {
                          this.router.navigate(['/app']);
                        }

                        if (Global.isAdmin(user)) {
                          this.router.navigate(['/app', 'admin', 'education', 'online-courses', params.onlineCourseId]);
                        } else if (Global.isManager(user) || Global.isStudent(user)) {
                          this.router.navigate(['/app', 'student', 'education', 'online-courses', params.onlineCourseId]);
                        } else {
                          this.router.navigate(['/app']);
                        }
                        break;
                      case SsoResourcesNavigationType.ProductSheet:
                        if (!params.productSheetId) {
                          this.router.navigate(['/app']);
                        }

                        if (Global.isAdmin(user)) {
                          this.router.navigate(['/app', 'admin', 'education', 'product-sheets', params.productSheetId]);
                        } else if (Global.isManager(user) || Global.isStudent(user)) {
                          this.router.navigate(['/app', 'student', 'education', 'product-sheets', params.productSheetId]);
                        } else {
                          this.router.navigate(['/app']);
                        }
                        break;
                      default:
                        this.router.navigate(['/app']);
                        break;
                    }
                  });
                });
              } else {
                this.router.navigate(['/app']);
              }
            }
          },
          (error) => {
            console.error(error);
            this.loading = false;
            this.errorMessage =
              (error && error.error && error.error.errors && error.error.errors.token && error.error.errors.token[0]) ||
              'Si è verificato un errore, contattare il supporto';
          }
        );
      });
    });
  }
}
